import { render } from "./index.vue?vue&type=template&id=0ee9b81e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=0ee9b81e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee9b81e"]])

export default __exports__